import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { Navigate } from "react-router-dom";
import { api } from "./api";
import { Loader2 } from "lucide-react";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch { setUser(null); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { console.debug("logout request failed", e?.message); }
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, setUser, loading, checkAuth, logout }}>{children}</AuthCtx.Provider>;
}

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex justify-center py-40"><Loader2 className="h-8 w-8 animate-spin text-brand-navy" /></div>;
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}
